module.exports = __webpack_public_path__ + "img/title.4d1c6e93.png";